import _ from 'lodash';
import Response from '../../models/Response';

export const ResponseSorts = {

  getTopRanked (responses, count = 5, reversed = false) {
    const result = _.slice(this.sortByMostPopularTopLevel(responses, reversed), 0, count);
    return reversed ? _.reverse(result) : result;
  },

  getTopRated (responses, count = 5) {
    const result = _.slice(this.sortByMostTotalRatingTopLevel(responses), 0, count);
    return result;
  },

  getNoteworthy (responses, reversed = false) {
    const result = [];

    // For each item, get it if its noteworthy, followed by its children if noteworthy
    for (let response of responses) {
      if (Response.isNoteworthy(response)) {
        result.push(response);
      }

      // If there are children, and any are noteworthy.
      if (Response.getChildrenCount(response) > 0) {
        for (let child of Response.getChildren(response)) {
          if (Response.isNoteworthy(child)) {
            result.push(child);
          }
        }
      }
    }

    return reversed ? _.reverse(result) : result;
  },

  sortByMostTotalRatingTopLevel (responses) {
    const result = _.clone(responses);
    result.sort((r1, r2) => {
      const r1Rating = Response.getTotalRating(r1);
      const r2Rating = Response.getTotalRating(r2);
      return r2Rating - r1Rating;
    });
    return result;
  },

  sortByMostPopularTopLevel (responses, reversed = false) {
    const result = _.clone(responses);
    result.sort((r1, r2) => {
      const r1Likes = Response.getLikes(r1);
      const r1Dislikes = Response.getDislikes(r1);
      const r1Comments = Response.getChildrenCount(r1);
      const r1Popularity = r1Likes - r1Dislikes;

      const r2Likes = Response.getLikes(r2);
      const r2Dislikes = Response.getDislikes(r2);
      const r2Comments = Response.getChildrenCount(r2);
      const r2Popularity = r2Likes - r2Dislikes;

      const likeCountDifference = r2Likes - r1Likes;
      const commentCountDifference = r2Comments - r1Comments;
      const popularityDifference = r2Popularity - r1Popularity;
      if (popularityDifference === 0) {
        if (likeCountDifference === 0) {
          if (commentCountDifference === 0) {
            // In the Angular app we compare created times
            // but the Post object does not give us a created_time field, so we
            // simply keep the order they were returned to us in
            return 0;
          } else {
            return commentCountDifference;
          }
        } else {
          return likeCountDifference;
        }
      } else {
        return popularityDifference;
      }
    });
    return reversed ? _.reverse(result) : result;
  }

};
